// removed by extract-text-webpack-plugin
module.exports = {"stars":"HNcAfsX_1PsS2L0ENPDbv","star":"_1YiJS-3tl-7FuIt8rwrGhM","filled":"_3iBKsIveGLqU_InjPm4vE-","starContainer":"xCLKnxTwG_mb2H0aCnG7C"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Stars.css
// module id = 171
// module chunks = 0